import getTopics from 'services/apiHelpers/getTopics';
import getInteractionsInTopic from 'services/apiHelpers/getInteractionsInTopic';

export default () =>
  getTopics().reduce((acc, curr) => {
    return [...acc, ...getInteractionsInTopic(curr).map(i => i.id)];
  }, []);
